export interface ClassProject {
  slug: string
  publishedProjectId: number
}

// Module state rather than context: the GA emitters mount above the class
// layout, so nothing it provides can reach them.
let currentClassProject: ClassProject | null = null

export function getClassProject() {
  return currentClassProject
}

export function setClassProject(classProject: ClassProject) {
  currentClassProject = classProject
}

export function clearClassProject(classProject: ClassProject) {
  // A newer class may already have taken over.
  if (currentClassProject === classProject) currentClassProject = null
}
